// extracted by mini-css-extract-plugin
export default {"price":"qja-z","onSale":"rja-z","msrpLabelPrice":"sja-z","msrpLabel":"tja-z","originalPrice":"uja-z"};